import { compose } from 'lodash/fp';
import { createPeerGroupTrackingStrategy } from './group';

export function createPeerTrackingStrategy() {
    return compose(createPeerGroupTrackingStrategy());
}
